import {
  faFile,
  faFileArchive,
  faFileAudio,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faLink,
  faStickyNote,
} from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import config from 'config'
import uniqueString from 'secure-random-string'
// import ReactGA from 'react-ga'

export const wait = (callback) => {
  setTimeout(callback, 0)
}

export const SET_ACCESS_TOKEN = (token) => {
  try {
    localStorage.setItem('token', token)
  } catch (err) {
    sessionStorage.setItem('token', token)
  }
}

export const UN_AUTH = () => {
  try {
    localStorage.removeItem('access_token')
    localStorage.removeItem('disclaimer')
  } catch (err) {
    sessionStorage.removeItem('access_token')
  }
}

export const IS_AUTHED = () => {
  return (
    sessionStorage.getItem('access_token') ||
    localStorage.getItem('access_token')
  )
}

export const BASE_URL = () => {
  switch (config.ENVIRONMENT) {
    case 'local':
      return `http://localhost:8080/local/api/public`
    case 'dev':
    case 'release':
      return `${config.host}/${config.id}/api/public`
    case 'production':
      return `${config.host}/${config.id}/api/public`
    default:
      return 'http://localhost/eduongo_svn/kiwi/api/public'
  }
}

export const BASE_URL_API = () => {
  switch (config.ENVIRONMENT) {
    case 'dev':
    case 'release':
    case 'production':
      return `${config.host}/${config.apiRoute}`
    default:
      return `http://localhost:${config.port}/${config.apiRoute}`
  }
}

// export const SOCKET_URL = () => {
//   switch (process.env.NODE_ENV) {
//     case "release":
//     case "production":
//       return `${config.host}`;
//     default:
//       return `localhost:${config.port}`;
//   }
// };

export const ACCESS_TOKEN = () => {
  return (
    // sessionStorage.getItem('access_token') ||
    // localStorage.getItem('access_token') ||
    // ''
    sessionStorage.getItem('token') || localStorage.getItem('token') || ''
  )
}

export const PROFILE_LINKS = [
  { name: 'My Profile', key: 'profile', icon: 'user', to: '/profile/personal' },
  // { name: 'Settings', key:'settings', icon: 'database', to: '/settings', access: [1, 2, 4] },
  // { name: 'Configuration', key:'configuration', icon: 'cog', to: '/config', access: [1]},
  { name: 'Switch back', key: 'switch_back', icon: 'sign-out-alt', to: '' },
  {
    name: 'Log out',
    key: 'logout',
    icon: 'sign-out-alt',
    to: '/logout',
    onClick: UN_AUTH,
  },
]

export const NAVIGATION = [
  { key: 'dashboard', name: 'Home', icon: 'home', to: '/dashboard' },
  {
    key: 'learning_plan',
    name: 'Learning PlanASD',
    icon: 'learning-plan',
    to: '/learning-plan',
  },
  {
    key: 'all_courses',
    name: 'All Course',
    icon: 'learning-plan',
    to: '/all-courses',
  },
  {
    key: 'compliance',
    name: 'Compliance',
    icon: 'learning-plan',
    to: '/compliance',
  },
  { key: 'my_library', name: 'My Library', icon: 'my-library', to: '/library' },
  { key: 'my_report', name: 'My Report', icon: 'my-report', to: '/report' },
  {
    key: 'manager_report',
    name: 'Manager Report',
    icon: 'manager-reports',
    to: '/manager-report',
  },
  {
    key: 'discussions',
    name: 'Discussions',
    icon: 'discussion',
    to: '/discussion',
  },
]

export const DATA_MODULES = [
  {
    key: 'course_group',
    name: 'Course Groups',
    icon: 'layer-group',
    to: '/settings/groups/',
  },
  {
    key: 'location',
    name: 'Locations',
    icon: 'map-marker-alt',
    to: '/settings/locations/',
  },
  {
    key: 'location_group',
    name: 'Location Groups',
    icon: 'globe',
    to: '/settings/location-groups/',
  },
  {
    key: 'user',
    name: 'User Management',
    icon: 'users-cog',
    to: '/settings/users/',
  },
  {
    key: 'role',
    name: 'Job Titles',
    icon: 'user-tie',
    to: '/settings/roles/',
  },
  // {
  // 	key: 'audit_trail',
  // 	name: 'Audit Trail',
  // 	icon: 'list-alt',
  // 	to: '/settings/audit-trail/',
  // },
]

export const SETTINGS_MODULES = [
  { key: 'general', name: 'General', to: '/config/general' },
  { key: 'course', name: 'Course', to: '/config/course' },
  { key: 'theme', name: 'Theme', to: '/config/theme' },
  { key: 'language', name: 'Language', to: '/config/language' },
]

export const MODULES = [
  { id: 'home', name: 'Home' },
  { id: 'learning_plan', name: 'Learning Plan' },
  { id: 'all_courses', name: 'Course Catalog' },
  { id: 'my_library', name: 'My Library' },
  { id: 'my_report', name: 'My Report' },
  { id: 'groups', name: 'Groups' },
  { id: 'manager_report', name: 'Manager Report' },
  { id: 'discussions', name: 'Discussions' },
]

export const ROUTE_WITHOUT_HEADER = (path) => {
  return [
    '/login',
    '/forgot-password',
    '/reset-password',
    '/signup',
    '/change-password',
  ].includes(path)
}

const NAVIGATION_ROUTES = [
  { to: '/dashboard' },
  { to: '/learning-plan' },
  { to: '/all-courses' },
  { to: '/library' },
  { to: '/report' },
  { to: '/manager-report' },
  { to: '/discussion' },
  { to: '/settings' },
  { to: '/profile' },
  { to: '/config' },
  { to: '/zoomAuth' },
]

export const ROUTE_WITHOUT_NAV = (path) => {
  path = path.split('/')
  path = `/${path[1]}`

  return !NAVIGATION_ROUTES.map((item) => item.to).includes(path)
}

export const randomNumber = () => Math.floor(Math.random() * Math.floor(100000))

export const randomString = () => uniqueString()

// export const getLabelText = (name) => {
// 	return config.label[name] || name
// }

export const getLabelText = (name, language, quizPassedPercentage) => {
  switch (name) {
    case 'Course Complete':
      return 'In progress'
    case 'Practice at Station':
      return 'Manager Approval'
    case 'Certified':
      return 'Certified'
    case 'Quiz Failed':
      return 'Quiz Failed'
    case 'Reassigned':
      return 'Reassigned'
    case 'Expired':
      return 'Expired'
    case 'Not Started':
      return 'Not started'
    default:
      return name
  }
}

export const getLabelForPublicCatalog = (
  status,
  percentage = undefined,
  publicCatalogPercentage
) => {
  switch (status) {
    case 0:
      return 'Not started'
    case 1:
      if (publicCatalogPercentage) {
        return `In Progress${percentage ? ` ${percentage}%` : ' 0%'}`
      } else {
        return `In Progress${percentage ? ` ${percentage}%` : ''}`
      }
    case 2:
      return 'Quiz Failed'
    case 3:
      return 'Manager Approval'
    case 4:
      return 'Certified'
    case 6:
      return 'Quiz Pending'
    default:
      return ''
  }
}

export const getUserType = (type, language) => {
  switch (type) {
    case 1:
      return language && language.admin
    case 2:
      return language && language.course_manager
    case 3:
      return language && language.employee
    case 4:
      return language && language.area_admin
    default:
      return type
  }
}

// export const getLabelColor = (name) => {
// 	return config.labelColor[name] || ''
// }

// export const getLabelIconColor = (name) => {
//     return config.labelIconColor[name] || ''
// }

// export const getColorFromStatus = (status) => {
//     return config.statusColor[status] || ''
// }

export const getGroupCompletionFromStatus = (
  status,
  language,
  checklistGroupApproval
) => {
  let groupStatus = status
  groupStatus = checklistGroupApproval === 1 && status >= 3 ? 5 : status

  switch (groupStatus) {
    case 1:
      return language ? language.in_progress : null
    case 2:
      return language ? language.quiz_failed : null
    case 3:
      return language ? language.validation : null
    case 4:
      return language ? language.certified : null
    case 5:
      return language ? language.validation : null
    default:
      break
  }
}

// export const initializeReactGA = () => ReactGA.initialize('UA-152054381-1')
// ReactGA.initialize(config.googleAnalytics.globalId)

// ReactGA.initialize(
// [
//     {
//         trackingId: config.googleAnalytics.globalId,
//         gaOptions: {
//             name: config.googleAnalytics.globalName
//         }
//     },
//     {
//         trackingId: config.googleAnalytics.clientId,
//         gaOptions: {
//             name: config.googleAnalytics.clientName
//         }
//     }
// ]
// )

// export const setReactGAPath = (path) => {
// ReactGA.pageview(`${process.env.CLIENT_ID}${path}`, ['tracker2'])
// }

export const getIconFileType = (type) => {
  switch (type) {
    case 'pdf':
      return faFilePdf
    case 'mp3':
      return faFileAudio
    case 'flac':
      return faFileAudio
    case 'mp4':
      return faFileVideo
    case 'docx':
      return faFileWord
    case 'xlsx':
      return faFileExcel
    case 'pptx':
      return faFilePowerpoint
    case 'zip':
      return faFileArchive
    case 'rar':
      return faFileArchive
    case 'png':
      return faFileImage
    case 'jpg':
      return faFileImage
    case 'jpeg':
      return faFileImage
    case 'gif':
      return faFileImage
    case 'csv':
      return faFileCsv
    case 'html':
      return faFileCode
    case 'py':
      return faFileCode
    case 'js':
      return faFileCode
    case 'php':
      return faFileCode
    case 'css':
      return faFileCode
    case 'ts':
      return faFileCode
    case 'note':
      return faStickyNote
    default:
      return faFile
  }
}

export const getStatusColor = (
  status,
  reassigned,
  expired,
  pastDue,
  courseConfig
) => {
  if (reassigned) return courseConfig.reassigned
  if (expired) return courseConfig.expired
  if (pastDue && status < 3) return courseConfig.pastDue
  else
    switch (status) {
      case 1:
        return courseConfig.inProgress
      case 2:
        return courseConfig.quizFailed
      case 3:
        return courseConfig.validation
      case 4:
        return courseConfig.completed
      default:
        break
    }
}

export const getStatusColorGroups = (
  status,
  reassigned,
  expired,
  pastDue,
  courseConfig,
  checklistGroupApproval
) => {
  let groupStatus = status
  groupStatus = checklistGroupApproval === 1 && status >= 3 ? 5 : status
  if (reassigned) return courseConfig.reassigned
  if (expired) return courseConfig.expired
  if (pastDue && status < 3) return courseConfig.pastDue
  else
    switch (groupStatus) {
      case 1:
        return courseConfig.inProgress
      case 2:
        return courseConfig.quizFailed
      case 3 && 5:
        return courseConfig.validation
      case 4:
        return courseConfig.completed
      default:
        break
    }
}

export const getStatusColorReport = (status, pastDue, courseConfig) => {
  switch (status) {
    case 0:
      return courseConfig.notStarted
    case 1:
      return courseConfig.inProgress
    case 2:
      return courseConfig.quizFailed
    case 3:
      return courseConfig.validation
    case 4:
      return courseConfig.completed
    default:
      break
  }
  return pastDue ? courseConfig.pastDue : null
}

export const validateEmail = (email) => {
  return /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )
}

export const hasIntersect = (arr1, arr2) => {
  if (Array.isArray(arr1) && Array.isArray(arr2)) {
    for (var i = 0; i < arr1.length; i++) {
      for (var k = 0; k < arr2.length; k++) {
        if (arr1[i] == arr2[k]) {
          return true
          break
        }
      }
    }
  }
  return false
}

export const objectToCsv = (object) => {
  let str =
    `${Object.keys(object[0])
      .filter((value) => {
        if (value != 'id') return `"${value}"`
      })
      .join(',')}` + '\n'

  return object.reduce((str, next) => {
    delete next.id

    if (next.status == 1) next.status = 'Active'
    else if (next.status == 2) next.status = 'Terminated'
    else next.status = 'Leave of Absence'

    if (next.access == 1) next.access = 'Admin'
    else if (next.access == 2) next.access = 'Course Manager'
    else if (next.access == 3) next.access = 'Employee'
    else if (next.access == 4) next.access = 'Area Admin'

    str +=
      `${Object.values(next)
        .map((value) => `"${value}"`)
        .join(',')}` + '\n'
    return str
  }, str)
}

// export const mesageSubstring = (message,amount) => {
//   return message.subString(0,amount)
// }

export const TimezoneSelector = (props) => (
  <select
    name='timezone'
    // defaultValue={props.timezone}
    value={props.timezone}
    placeholder='Select Timezone'
    onChange={props.onChangeTrainingForm}
    className='btn btn-default btn-has-dropdown'
    style={{ border: 'none' }}
  >
    <option disabled value=''>
      Select Timezone
    </option>
    <option value='Etc/GMT+12'>(GMT-12:00) International Date Line West</option>
    <option value='Pacific/Midway'>(GMT-11:00) Midway Island, Samoa</option>
    <option value='Pacific/Honolulu'>(GMT-10:00) Hawaii</option>
    <option value='US/Alaska'>(GMT-09:00) Alaska</option>
    <option value='America/Los_Angeles'>
      (GMT-08:00) Pacific Time (US & Canada)
    </option>
    <option value='America/Tijuana'>
      (GMT-08:00) Tijuana, Baja California
    </option>
    <option value='US/Arizona'>(GMT-07:00) Arizona</option>
    <option value='America/Chihuahua'>
      (GMT-07:00) Chihuahua, La Paz, Mazatlan
    </option>
    <option value='US/Mountain'>(GMT-07:00) Mountain Time (US & Canada)</option>
    <option value='America/Managua'>(GMT-06:00) Central America</option>
    <option value='US/Central'>(GMT-06:00) Central Time (US & Canada)</option>
    <option value='America/Mexico_City'>
      (GMT-06:00) Guadalajara, Mexico City, Monterrey
    </option>
    <option value='Canada/Saskatchewan'>(GMT-06:00) Saskatchewan</option>
    <option value='America/Bogota'>
      (GMT-05:00) Bogota, Lima, Quito, Rio Branco
    </option>
    <option value='US/Eastern'>(GMT-05:00) Eastern Time (US & Canada)</option>
    <option value='US/East-Indiana'>(GMT-05:00) Indiana (East)</option>
    <option value='Canada/Atlantic'>(GMT-04:00) Atlantic Time (Canada)</option>
    <option value='America/Caracas'>(GMT-04:00) Caracas, La Paz</option>
    <option value='America/Manaus'>(GMT-04:00) Manaus</option>
    <option value='America/Santiago'>(GMT-04:00) Santiago</option>
    <option value='Canada/Newfoundland'>(GMT-03:30) Newfoundland</option>
    <option value='America/Sao_Paulo'>(GMT-03:00) Brasilia</option>
    <option value='America/Argentina/Buenos_Aires'>
      (GMT-03:00) Buenos Aires, Georgetown
    </option>
    <option value='America/Godthab'>(GMT-03:00) Greenland</option>
    <option value='America/Montevideo'>(GMT-03:00) Montevideo</option>
    <option value='America/Noronha'>(GMT-02:00) Mid-Atlantic</option>
    <option value='Atlantic/Cape_Verde'>(GMT-01:00) Cape Verde Is.</option>
    <option value='Atlantic/Azores'>(GMT-01:00) Azores</option>
    <option value='Africa/Casablanca'>
      (GMT+00:00) Casablanca, Monrovia, Reykjavik
    </option>
    <option value='Etc/Greenwich'>
      (GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London
    </option>
    <option value='Europe/Amsterdam'>
      (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna
    </option>
    <option value='Europe/Belgrade'>
      (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague
    </option>
    <option value='Europe/Brussels'>
      (GMT+01:00) Brussels, Copenhagen, Madrid, Paris
    </option>
    <option value='Europe/Sarajevo'>
      (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb
    </option>
    <option value='Africa/Lagos'>(GMT+01:00) West Central Africa</option>
    <option value='Asia/Amman'>(GMT+02:00) Amman</option>
    <option value='Europe/Athens'>
      (GMT+02:00) Athens, Bucharest, Istanbul
    </option>
    <option value='Asia/Beirut'>(GMT+02:00) Beirut</option>
    <option value='Africa/Cairo'>(GMT+02:00) Cairo</option>
    <option value='Africa/Harare'>(GMT+02:00) Harare, Pretoria</option>
    <option value='Europe/Helsinki'>
      (GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius
    </option>
    <option value='Asia/Jerusalem'>(GMT+02:00) Jerusalem</option>
    <option value='Europe/Minsk'>(GMT+02:00) Minsk</option>
    <option value='Africa/Windhoek'>(GMT+02:00) Windhoek</option>
    <option value='Asia/Kuwait'>(GMT+03:00) Kuwait, Riyadh, Baghdad</option>
    <option value='Europe/Moscow'>
      (GMT+03:00) Moscow, St. Petersburg, Volgograd
    </option>
    <option value='Africa/Nairobi'>(GMT+03:00) Nairobi</option>
    <option value='Asia/Tbilisi'>(GMT+03:00) Tbilisi</option>
    <option value='Asia/Tehran'>(GMT+03:30) Tehran</option>
    <option value='Asia/Muscat'>(GMT+04:00) Abu Dhabi, Muscat</option>
    <option value='Asia/Baku'>(GMT+04:00) Baku</option>
    <option value='Asia/Yerevan'>(GMT+04:00) Yerevan</option>
    <option value='Asia/Kabul'>(GMT+04:30) Kabul</option>
    <option value='Asia/Yekaterinburg'>(GMT+05:00) Yekaterinburg</option>
    <option value='Asia/Karachi'>
      (GMT+05:00) Islamabad, Karachi, Tashkent
    </option>
    <option value='Asia/Calcutta'>
      (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi
    </option>
    <option value='Asia/Calcutta'>(GMT+05:30) Sri Jayawardenapura</option>
    <option value='Asia/Katmandu'>(GMT+05:45) Kathmandu</option>
    <option value='Asia/Almaty'>(GMT+06:00) Almaty, Novosibirsk</option>
    <option value='Asia/Dhaka'>(GMT+06:00) Astana, Dhaka</option>
    <option value='Asia/Rangoon'>(GMT+06:30) Yangon (Rangoon)</option>
    <option value='Asia/Bangkok'>(GMT+07:00) Bangkok, Hanoi, Jakarta</option>
    <option value='Asia/Krasnoyarsk'>(GMT+07:00) Krasnoyarsk</option>
    <option value='Asia/Hong_Kong'>
      (GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi
    </option>
    <option value='Asia/Kuala_Lumpur'>
      (GMT+08:00) Kuala Lumpur, Singapore
    </option>
    <option value='Asia/Irkutsk'>(GMT+08:00) Irkutsk, Ulaan Bataar</option>
    <option value='Australia/Perth'>(GMT+08:00) Perth</option>
    <option value='Asia/Taipei'>(GMT+08:00) Taipei</option>
    <option value='Asia/Tokyo'>(GMT+09:00) Osaka, Sapporo, Tokyo</option>
    <option value='Asia/Seoul'>(GMT+09:00) Seoul</option>
    <option value='Asia/Yakutsk'>(GMT+09:00) Yakutsk</option>
    <option value='Australia/Adelaide'>(GMT+09:30) Adelaide</option>
    <option value='Australia/Darwin'>(GMT+09:30) Darwin</option>
    <option value='Australia/Brisbane'>(GMT+10:00) Brisbane</option>
    <option value='Australia/Canberra'>
      (GMT+10:00) Canberra, Melbourne, Sydney
    </option>
    <option value='Australia/Hobart'>(GMT+10:00) Hobart</option>
    <option value='Pacific/Guam'>(GMT+10:00) Guam, Port Moresby</option>
    <option value='Asia/Vladivostok'>(GMT+10:00) Vladivostok</option>
    <option value='Asia/Magadan'>
      (GMT+11:00) Magadan, Solomon Is., New Caledonia
    </option>
    <option value='Pacific/Auckland'>(GMT+12:00) Auckland, Wellington</option>
    <option value='Pacific/Fiji'>
      (GMT+12:00) Fiji, Kamchatka, Marshall Is.
    </option>
    <option value='Pacific/Tongatapu'>(GMT+13:00) Nuku'alofa</option>
  </select>
)

export const getPdfjsUrl = (pdfjsDownloadAndPrint = false) => {
  if (pdfjsDownloadAndPrint) {
    return 'https://d2x2yurzgc1veb.cloudfront.net/pollozone-pdfjs/pdfjs/web/viewer.html?file='
  }

  return 'https://d2x2yurzgc1veb.cloudfront.net/pdfjs/web/viewer.html?file='
}

export function isTextEmpty(text) {
  let cleanedText = text.replace(/<\/?[^>]+(>|$)/g, '')
  cleanedText = cleanedText.replace(/&nbsp;|\s|\t|\n|\r/g, '')
  return cleanedText.length === 0
}

export function isValidURL(url) {
  const pattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/
  return pattern.test(url)
}

export function formatDate(dateStr) {
  const date = new Date(dateStr)

  const day = date.getDate()
  const month = date.toLocaleString('default', { month: 'long' })

  return `${day} ${month}`
}

export function formatTime(dateStr) {
  const date = new Date(dateStr)

  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  return `${hours}:${minutes}`
}

export const formatTimerTime = (seconds) => {
  const m = String(Math.floor(seconds / 60)).padStart(2, '0')
  const s = String(seconds % 60).padStart(2, '0')
  return `${m}:${s}`
}

export const formatGroupMessageDate = (dateString) => {
  const date = new Date(dateString)
  const day = date.getDate()
  const month = date.toLocaleDateString('en-US', { month: 'long' })

  return `${day} ${month}`
}

export function setMessagesExpirePeriod(periodString) {
  switch (periodString) {
    case '1 m':
      return { name: '1 month', value: '1 m' }
    case '6 m':
      return { name: '6 months', value: '6 m' }
    case '1 y':
      return { name: '1 year', value: '1 y' }
    default:
      return 'Wrong period'
  }
}

export function millisecondsToHoursMinutes(milliseconds) {
  var seconds = milliseconds / 1000

  var hours = Math.floor(seconds / 3600)

  var remainingSeconds = seconds % 3600

  var minutes = Math.floor(remainingSeconds / 60)

  return `${hours}h, ${minutes}m`
}

export function getTimeAgo(dateString) {
  const inputDate = new Date(dateString)
  const now = new Date()
  const diffInMilliseconds = now - inputDate
  const diffInSeconds = Math.floor(diffInMilliseconds / 1000)
  const diffInMinutes = Math.floor(diffInSeconds / 60)
  const diffInHours = Math.floor(diffInMinutes / 60)
  const diffInDays = Math.floor(diffInHours / 24)
  const diffInWeeks = Math.floor(diffInDays / 7)

  if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`
  } else if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`
  } else if (diffInDays <= 14) {
    return `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`
  } else {
    return `${diffInWeeks} week${diffInWeeks === 1 ? '' : 's'} ago`
  }
}

export function formatToAmPm(time) {
  if (!time) return ''

  const [hourStr, minute] = time.split(':')
  const hour = parseInt(hourStr, 10)

  const suffix = hour >= 12 ? 'PM' : 'AM'

  return `${time} ${suffix}`
}

export function generateOfferLetter(template, data) {
  return template.replace(/\{(.*?)\}/g, (_, key) => data[key.trim()] ?? '')
}
